module.exports = __webpack_public_path__ + "static/img/samajuri (30).0021eac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (30).jpg
// module id = UKlN
// module chunks = 0